import { render, staticRenderFns } from "./itemlist.vue?vue&type=template&id=4b90a530&"
import script from "./itemlist.vue?vue&type=script&lang=ts&"
export * from "./itemlist.vue?vue&type=script&lang=ts&"
import style0 from "./itemlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports